import React, { memo, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { PageTemplate } from "../../components/templates";
import { Stack } from "investira.react.components";
import AtivosList from "./AtivosList";
import Carteira from "./Carteira";
import useKickBack from "../../hooks/useKickBack";
import withMessage from "../../hoc/withMessage";
import RecursoGarantidorProvider from "../../contexts/RecursoGarantidorContext";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import CustodianteActions from "./CustodianteActions";

const CarteiraEdit = memo((props) => {
  const params = useParams();
  const location = useLocation();

  const xCid = new URLSearchParams(location.search).get("cid");
  const hasCid = xCid ? true : false;

  const kick = useKickBack();

  const { state } = useCarteirasContext();

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  return (
    <RecursoGarantidorProvider
      tipo="carteira"
      carteiraId={state.carteira_id}
      dataPosicao={state.data_posicao}
    >
      <PageTemplate
        title="Carteira"
        maxWidth={false}
        headerRenderActions={<CustodianteActions hasCid={hasCid} />}
      >
        <Stack spacing={2}>
          <Carteira id={params.id} mode="read" hasCid={hasCid} />
          <AtivosList carteiraId={params.id} hasCid={hasCid} />
        </Stack>
      </PageTemplate>
    </RecursoGarantidorProvider>
  );
});

CarteiraEdit.displayName = "CarteiraEdit";

export default withMessage(CarteiraEdit);
